import { FacilitiesRepository } from "lib/repositories/index";
import st from "lib/utils/index";
import { createResourceInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "products/EditProductView/StepAccommodationSetttings/INITIALIZE_VIEW";
export const DESTROY_VIEW = "products/EditProductView/StepAccommodationSetttings/DESTROY_VIEW";
export const FETCH_FACILITIES = "products/EditProductView/StepAccommodationSetttings/FETCH_FACILITIES";
export const FETCH_FACILITIES_START = "products/EditProductView/StepAccommodationSetttings/FETCH_FACILITIES_START";
export const FETCH_FACILITIES_SUCCESS = "products/EditProductView/StepAccommodationSetttings/FETCH_FACILITIES_SUCCESS";
export const FETCH_FACILITIES_FAILURE = "products/EditProductView/StepAccommodationSetttings/FETCH_FACILITIES_FAILURE";

export const stateSelector = (state) => state.products.EditProductView;

const facilitiesResource = createResourceInstance({
  FETCH: FETCH_FACILITIES,
  FETCH_START: FETCH_FACILITIES_START,
  FETCH_SUCCESS: FETCH_FACILITIES_SUCCESS,
  FETCH_FAILURE: FETCH_FACILITIES_FAILURE,
  stateSelector,
  stateKey: "facilities",
  getModel: () => {
    return FacilitiesRepository.findAll();
  },
});

const initialState = {
  facilities: facilitiesResource.initialState,
};

const reducers = {
  ...facilitiesResource.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,
};

const epics = [...facilitiesResource.epics, (actions$) => actions$.ofType(INITIALIZE_VIEW).mapTo(fetchFacilities())];

export const { fetch: fetchFacilities } = facilitiesResource.actions;

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepAccommodationSettings/index.js